export default __webpack_public_path__ + "static/media/pixels-project-3.6b3cef08.jpg";